<div class="modal-header">
  @if (addNewProperty) {
    <h4 class="modal-title">{{'editPropertyPopup.title.new' | translate}}</h4>
  } @else {
    <h4 class="modal-title">{{'editPropertyPopup.title.edit' | translate}}</h4>
  }
</div>
<div class="modal-body pt-0">
  <div class="modal-body-inner">
    <form novalidate [formGroup]="form">
      <div class="mb-3 row">
        <label class="col-md-4 col-form-label">{{'property.type.label' | translate}}</label>
        <div class="col-md-8">
          <select class="form-control" id="propertyType" name="propertyType" formControlName="propertyType" (change)="switchPropertyNames()">
            <option [ngValue]="PropertyTypes.BEHAVIOR">{{'property.type.behavior' | translate}}</option>
            @if (showPlausi) {
              <option [ngValue]="PropertyTypes.PLAUSI">{{'property.type.plausi' | translate}}</option>
            }
            @if (showAccepting) {
              <option [ngValue]="PropertyTypes.ACCEPTING">{{'property.type.accepting' | translate}}</option>
            }
            @if (showGiving) {
              <option [ngValue]="PropertyTypes.GIVING">{{'property.type.giving' | translate}}</option>
            }
          </select>
        </div>
      </div>
      <div class="mb-3 row">
        <label class="col-md-4 col-form-label">{{'property.name.label' | translate}}</label>
        <div class="col-md-8">
          <select class="form-control" id="propertyName" name="propertyName" formControlName="propertyName"
            (change)="updatePropertyValueTypesAndDescription()"
            [class.is-invalid]="form.controls?.propertyName?.touched && form.controls?.propertyName?.invalid">
            <option [ngValue]=""></option>
            @for (propertyName of propertyNames; track $index) {
              <option [ngValue]="propertyName">{{propertyName}}</option>
            }
          </select>
        </div>
      </div>
      <div class="mb-3 row">
        <label class="col-md-4 col-form-label">{{'property.valueType.label' | translate}}</label>
        <div class="col-md-8">
          <select class="form-control" id="propertyValueType" name="propertyValueType" formControlName="propertyValueType"
            [appDisableControl]="!form?.controls?.propertyName?.value" (change)="propertyValueTypeChangedHandler()"
            [class.is-invalid]="form.controls?.propertyValueType?.touched && form.controls?.propertyValueType?.invalid">
            @for (valueType of valueTypes; track $index) {
              <option [ngValue]="valueType.value">{{valueType.name}}</option>
            }
          </select>
        </div>
      </div>
      <div class="mb-3 row">
        <label class="col-md-4 col-form-label">
          {{ ( isSecondInputHidden(form.controls?.propertyValueType?.value) ? 'property.value.label' : 'property.value.range.min') | translate}}
        </label>
        <div class="col-md-8">
          @if (propertyName !== 'defaultText') {
            <input #firstPropertyInputEl class="form-control" type="text" formControlName="firstPropertyInput"
              inputRestricter="{{inputValueRestricter}}"
              [appDisableControl]="!form.controls?.propertyValueType?.value"
              [class.is-invalid]="form.controls?.firstPropertyInput?.touched && form.controls?.firstPropertyInput?.invalid">
            <div class="invalid-feedback">{{getInputError(form.get('firstPropertyInput'))}}</div>
          } @else {
            <div class="default-text-editor">
              <div id="quill-toolbar">
                <span class="ql-formats">
                  <select class="ql-size">
                    <option value="10px">5px</option>
                    <option value="12px">6px</option>
                    <option value="14px">7px</option>
                    <option value="16px">8px</option>
                    <option value="18px">9px</option>
                    <option value="20px">10px</option>
                    <option value="22px">11px</option>
                    <option value="24px">12px</option>
                    <option value="28px">14px</option>
                    <option value="32px">16px</option>
                    <option value="36px">18px</option>
                    <option value="40px">20px</option>
                    <option value="44px">22px</option>
                    <option value="48px">24px</option>
                    <option value="52px">26px</option>
                    <option value="56px">28px</option>
                    <option value="72px">36px</option>
                  </select>
                </span>
                <span class="ql-formats">
                  <select class="ql-color">
                    <option value="#000000"></option>
                    <option value="#ff0000"></option>
                    <option value="#ffffff"></option>
                    <option value="#0ef109"></option>
                  </select>
                </span>
                <span class="ql-formats">
                  <select class="ql-rotation">
                    <option value="0">0°</option>
                    <option value="90">90°</option>
                    <option value="180">180°</option>
                    <option value="270">270°</option>
                  </select>
                </span>
                <span class="ql-formats">
                  <select class="ql-align">
                    <option value=""></option>
                    <option value="center"></option>
                    <option value="right"></option>
                  </select>
                </span>
                <span class="ql-formats">
                  <select class="ql-valign">
                    <option value="-1">top</option>
                    <option value="0">middle</option>
                    <option value="1">bottom</option>
                  </select>
                </span>
              </div>
              <quill-editor
                [modules]="quillModules"
                [formControl]="$any(form.get('firstPropertyInput'))"
                (onEditorCreated)="onQuillEditorCreated($event)">
              </quill-editor>
            </div>
          }
        </div>
      </div>
      @if (!isSecondInputHidden(form.controls?.propertyValueType?.value)) {
        <div class="mb-3 row">
          <label class="col-md-4 col-form-label">
            {{ ( isSecondInputHidden(form.controls?.propertyValueType?.value) ? 'property.value.label' : 'property.value.range.max') | translate}}
          </label>
          <div class="col-md-8">
            <input class="form-control" type="text" formControlName="secondPropertyInput"
              inputRestricter="{{inputValueRestricter}}"
              [appDisableControl]="!form.controls?.propertyValueType?.value"
              [class.is-invalid]="form.controls?.secondPropertyInput?.touched && form.controls?.secondPropertyInput?.invalid">
            <div class="invalid-feedback">{{getInputError(form.get('secondPropertyInput'))}}</div>
          </div>
        </div>
      }
    </form>
    <div class="text-end">
      @if (metaElement || article) {
        @if (selectedPropertyValue) {
          <button class="btn btn-secondary btn-circular me-1"
                  [disabled]="!form.controls?.propertyValueType?.value" (click)="resetEditValue()">
            <i class="mdi mdi-close"></i>
          </button>
          <button class="btn btn-primary btn-circular"
                  [disabled]="!form.controls?.propertyValueType?.value" (click)="changePropertyValue()">
            <i class="mdi mdi-check"></i>
          </button>
        } @else {
          <button class="btn btn-primary btn-circular"
                  [disabled]="!form.controls?.propertyValueType?.value || propertyValueError || form.invalid"
                  (click)="addPropertyValue()">
            <i class="mdi mdi-plus"></i>
          </button>
        }
      }
    </div>
    @if (property) {
      <table class="table table-striped table-hover table-sm">
        <thead>
          <tr>
            <th class="property-valueType">{{'property.valueType.label' | translate}}</th>
            <th class="property-value">{{'property.value.label' | translate}}</th>
            <th class="actions"></th>
          </tr>
        </thead>
        <tbody>
          @for (propertyValue of property.values; track $index; let i = $index) {
            <tr class="middle no-text-selection" [class.active]="selectedPropertyValue === propertyValue"
              (click)="toggleSelectedPropertyValue(propertyValue)">
              <td>
                <span class="px-1">{{getType(propertyValue)}}</span>
              </td>
              <td>
                <span class="px-1 din-font-display">{{getDisplayValue(propertyValue)}}</span>
              </td>
              <td class="text-end">
                <span (click)="deletePropertyValue(propertyValue, i)">
                  <i class="mdi mdi-delete"></i>
                </span>
              </td>
            </tr>
          }
        </tbody>
      </table>
    }
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary btn-cancel" (click)="close()">
    {{'global.label.cancel' | translate}}
  </button>
  <button type="button" class="btn btn-primary" (click)="saveClickHandler()" [disabled]="!validateForm()">
    {{'global.label.accept' | translate}}
  </button>
</div>
